module.exports = __webpack_public_path__ + "img/iluni-ui.e4b60786.png";